import { render, staticRenderFns } from "./management-library-processing-adjective-form.vue?vue&type=template&id=00fa245a"
import script from "./management-library-processing-adjective-form.vue?vue&type=script&lang=js"
export * from "./management-library-processing-adjective-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports